import * as mutations from './mutations'
import * as actions from './actions'
import state from './state'


export default {
    namespaced: true,
    mutations,
    actions,
    state
}


// WEBPACK FOOTER //
// ./src/modules/inventory-users/index.js